import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./NavBar.css";

import hamburger from "../../assets/icons/hamburger.svg";
import close from "../../assets/icons/close-red.svg";
import MobileNav from "./MobileNav";
import outreach_logo from "../../assets/outreach_logo_black.svg"

export default function NavBar() {
    const [showMobile, setShowMobile] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <header className={isScrolled ? "scrolled" : ""}>
            <nav>
                <div className="main_navbar">
                    <div className="navbar_left">
                        <div className="navbar_logo">
                            <Link to="/">
                                <img src={outreach_logo} alt="logo" />
                            </Link>
                        </div>
                        <div className="hamburger_icon" onClick={() => setShowMobile(!showMobile)}>
                            <img src={showMobile ? close : hamburger} alt="Menu" />
                        </div>
                    </div>
                    <ul className="navbar_items">
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/about">About</Link></li>
                        <li><Link to="/programs">Programs</Link></li>
                        <li className="highlight-tab"><a href="https://experience.iitd.ac.in" target="_blank" rel="noopener noreferrer">#ExperienceIITD</a></li>
                        <li><Link to="/releases">Releases</Link></li>
                        <li><Link to="/gallery">Gallery</Link></li>
                        <li><Link to="/team">Team</Link></li>
                        <li><Link to="/contact">Contact</Link></li>
                    </ul>
                </div>
                <MobileNav showMobile={showMobile} setShowMobile={setShowMobile} />
            </nav>
        </header>
    );
}
